// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2Gcg6","buttons":"PendingPaymentAlert_buttons__nvr2M"};